import { defineStore } from "pinia";
import { setting } from "@/utils/api";
const useSettingStore = defineStore("useSettingStore", {
    state: () => ({
        info: {},
        is_start: "",
        recordNum: 0
    }),
    getters: {
        isGet() {
            return Object.keys(this.info).length > 0;
        }
    },
    actions: {
        resetInfo() {
            this.$reset();
        },
        async getSetting() {
            const res = await setting();
            this.info = res.data;
            this.is_start = res.data.is_start;
        },
        async getRecord() {
            const res = await joinRecord();
            ;
        }

    },
    persist: {
        enabled: false,
    },
});

export default useSettingStore;
